import React from "react";

function SelectionFilter({ filter, onChange, defaultValue = "" }) {
  const { name, options } = filter;
  return (
    <div className="group" key={name}>
      <label>
        <div className="select-wrapper">
          <select
            id={name}
            data-testid={filter.label}
            value={defaultValue}
            onChange={(event) => onChange(event, filter.value, "value")}
          >
            {
              options.length > 0 ? (options.map(
                (option) => (
                  <option key={option.name} value={option.value}>
                    {option.name}
                  </option>
                )
              )) : (<option value="loading">
                      ...
                    </option>)}
          </select>
        </div>
      </label>
    </div>
  );
}

export default SelectionFilter;
